import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../services/api';
import toast from 'react-hot-toast';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('darkMode') === 'true';
  });

  // Apply dark mode class ke <html>
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode(v => {
    const next = !v;
    localStorage.setItem('darkMode', String(next));
    return next;
  });

  const fetchMe = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) { setLoading(false); return; }
      const { data } = await authAPI.getMe();
      setUser(data.user);
    } catch { localStorage.removeItem('token'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  // Owner UI dark-only (Layout memaksa main #0f172a & toggle disembunyikan
  // di Sidebar). Force darkMode=true tanpa syarat supaya .card & komponen
  // shared dengan varian dark: ikut render sebagai dark. Menormalisasi
  // stale localStorage=false dari owner yg toggle sebelum toggle ditutup.
  useEffect(() => {
    if (user?.role === 'owner' && !darkMode) {
      localStorage.setItem('darkMode', 'true');
      setDarkMode(true);
    }
  }, [user, darkMode]);

  const login = async (username, password) => {
    const { data } = await authAPI.login({ username, password });
    localStorage.setItem('token', data.token);
    setUser(data.user);
    return data;
  };

  const loginWithGoogle = async (credential) => {
    const { data } = await authAPI.google({ credential });
    localStorage.setItem('token', data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    toast.success('Berhasil logout');
  };

  const isAdmin      = user?.role === 'admin' || user?.role === 'superadmin';
  const isSuperAdmin = user?.role === 'superadmin';
  const isOwner      = user?.role === 'owner';
  const cabang       = user?.cabang || null;

  return (
    <AuthContext.Provider value={{
      user, login, loginWithGoogle, logout, loading,
      isAdmin, isSuperAdmin, isOwner, cabang, fetchMe,
      darkMode, toggleDarkMode
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
